'use client'
import styled from 'styled-components'
import ErrorGrid from '../error-grid'
import HeaderInit from '../header-init'

const DownArrow = styled.div`
    margin: 15px 0 30px 0;
`

const GeoBlockedImg = styled.div`
    img {
        display: inline;
    }
    source {
        display: inline;
    }
`

const GeoBlocked = () => {
    return (
        <HeaderInit routeName="/geo-blocked">
            <GeoBlockedImg className="flex-col text-center text-giphyWhite">
                <picture>
                    <source type="image/webp" srcSet="https://media.giphy.com/media/ys3xvXRwsdjoYvYR3h/giphy.webp" />
                    <img
                        src="https://media.giphy.com/media/ys3xvXRwsdjoYvYR3h/giphy.gif"
                        width="350"
                        alt="Content unavailable in your location"
                        className="ci-hidden h-[22.25rem]"
                    />
                </picture>
                <h3>Oops! This content is not</h3>
                <h3>available in your current location.</h3>
                <DownArrow className="ss-icon ss-navigatedown" />
                <ErrorGrid />
            </GeoBlockedImg>
        </HeaderInit>
    )
}
export default GeoBlocked
